import styled from 'styled-components';

const DiscountsTableWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 38px 26px 26px;
  overflow-x: auto;

  &.empty {
    overflow-x: hidden;
    .MuiTable-root {
      min-width: 0;
    }
  }

  .MuiTableCell-root.noDataCell {
    text-align: center;
    border-bottom: none;
  }

  .MuiTableCell-head {
    color: #172751;
    font-size: 14px;
    font-weight: 700;
    &.headTableCell {
      padding-top: 23px;
      padding-bottom: 16px;
    }
    > div {
      color: #172751 !important;
      font-size: 14px !important;
      font-weight: 700 !important;
    }
  }

  .MuiTableCell-body {
    color: #172751;
    font-size: 14px;
    font-weight: 400;
  }

  .MuiTable-root {
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;
    min-width: 1300px;

    .MuiTableRow-root td:first-child,
    .MuiTableRow-root td:last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    tr {
      &:first-child {
        th {
          white-space: pre;
          border-bottom: 1px solid #d9d9d9;
          &:nth-child(1) {
            width: 280px;
          }
          &:nth-child(2) {
            width: 80px;
          }
          &:nth-child(3) {
            width: 120px;
          }
          &:nth-child(4) {
            width: 140px;
          }
          &:nth-child(5) {
            width: 220px;
          }
          &:nth-child(6) {
            width: 140px;
          }
          &:nth-child(7) {
            width: 90px;
          }
          &:nth-child(8) {
            width: 120px;
          }
          &:nth-child(9) {
            width: 120px;
          }
          &:nth-child(10) {
            width: 140px;
          }
          &:nth-child(11) {
            width: 100px;
          }
          &:nth-child(12) {
            width: 60px;
          }
        }
      }
    }
  }

  .tableRow {
    background-color: transparent !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  .MuiTableCell-root {
    border-bottom: 1px solid #eef0f4;
    padding: 18px 20px;
    white-space: nowrap;
    &:first-child {
      padding-left: 4px;
    }
    &:last-child {
      padding-right: 4px;
    }
  }
  .MuiTableCell-body {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .TableBottomIndent {
    display: none;
  }

  .IconPercentType {
    height: 19px;
    svg {
      height: 100%;
    }
  }
  .IconDollarType {
    height: 22px;
    svg {
      height: 100%;
    }
  }

  .PopperAction {
    height: 24px;
  }
`;

export const StatusHeaderDropdown = styled.span`
  position: relative;
  display: inline-flex;
`;

export const StatusHeaderTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  font-weight: 700;
  color: #172751;
  cursor: pointer;
  font-family: inherit;

  img {
    width: 11px;
    height: 15px;
    display: block;
    @media (max-width: 1440px) {
      width: 10px;
      height: 14px;
    }
  }
`;

export const StatusHeaderMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 180px;
  background: #fff;
  box-shadow: 0px 5px 10px 0px #00000033;
  padding: 6px;
  z-index: 1300;
`;

export const StatusHeaderMenuItem = styled.button`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  text-align: left;
  border: none;
  background: transparent;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 500;
  color: #172751;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    background: #f3f4f6;
  }

  &.isActive {
    font-weight: 700;
  }
`;

export default DiscountsTableWrapper;
